export default "__VITE_ASSET__WfC2gS7k__"